import {
  COLOR_NEUTRAL_FOUR,
  COLOR_NEUTRAL_NINE,
  COLOR_NEUTRAL_THREE,
  GRID_GUTTER_WIDTH,
} from '@myre/common-styles';

import { type TooltipOptions } from 'chart.js';

import { type ChartType } from './enums';

const TOOLTIP_SPACING = GRID_GUTTER_WIDTH;
const TOOLTIP_ITEM_PADDING = 8;
const FONT_FAMILY = 'Roboto, sans-serif';
const FONT_SIZE = 14;

export const defaultTooltip = {
  // TODO: LIB-337 Create a custom mode to vertically align the tooltip with the bar
  mode: 'nearest',
  displayColors: false,

  // general style
  padding: TOOLTIP_SPACING,
  backgroundColor: COLOR_NEUTRAL_NINE,
  cornerRadius: 2,
  bodySpacing: TOOLTIP_ITEM_PADDING,

  // title style
  titleColor: COLOR_NEUTRAL_THREE,
  titleMarginBottom: TOOLTIP_SPACING,
  titleFont: {
    family: FONT_FAMILY,
    size: FONT_SIZE,
    weight: 500,
  },

  // body style
  bodyColor: COLOR_NEUTRAL_FOUR,
  bodyFont: {
    family: FONT_FAMILY,
    size: FONT_SIZE,
    weight: 400,
  },
} satisfies Partial<TooltipOptions<ChartType>>;
